<script>
import ModelIcon from "../layout/model-icon.vue";

export default {
  name: "model-list",
  components: {ModelIcon},
  props: {
    models: Array
  }
}
</script>

<template>
  <b-list-group>
    <b-list-group-item v-for="(model,idx) in models" :key="idx" class="d-flex flex-row"
                       @click="model.denied ? null : $emit('click', model)" :button="!model.denied">
      <div class="my-auto mr-4">
        <model-icon :model="model.model"/>
      </div>
      <div class="d-flex flex-column flex-fill">
        <div class="d-flex flex-row">
          <div class="h6 mb-1 flex-fill">{{ model.gli }}</div>
          <div v-if="model.when" class="text-muted">{{ model.when | timediff}}</div>
        </div>
        <p class="mb-1">{{ model.desc }}</p>
        <div>
          <b-badge size="sm" variant="danger" v-if="model.denied">Requires {{ model.denied }}</b-badge>
        </div>
      </div>
    </b-list-group-item>
  </b-list-group>
</template>

<style scoped>

</style>